import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarFilterItem from '../VeltCommentsSidebarFilterItem/VeltCommentsSidebarFilterItem';
import VeltCommentsSidebarFilterName from '../VeltCommentsSidebarFilterName/VeltCommentsSidebarFilterName';
import VeltCommentsSidebarFilterViewAll from '../VeltCommentsSidebarFilterViewAll/VeltCommentsSidebarFilterViewAll';
import VeltCommentsSidebarFilterSearch from '../VeltCommentsSidebarFilterSearch/VeltCommentsSidebarFilterSearch';
var VeltCommentsSidebarFilterLocation = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-location-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterLocation.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterLocation.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterLocation.ViewAll = VeltCommentsSidebarFilterViewAll;
VeltCommentsSidebarFilterLocation.Search = VeltCommentsSidebarFilterSearch;
export default VeltCommentsSidebarFilterLocation;
